import logo from "./logo.svg";
import "./App.css";
import { AnimateOnView } from "animatore-on-view";
import { AnimateObject } from "animatore-on-view";
const animateLogo = {
  hidden: {
    opacity: 0,
    rotate: 0,
    x: "-100%",
  },
  visible: {
    x: 0,
    opacity: 1,
    rotate: 360,
    transition: {
      delay: 0.4,
      duration: 2,
    },
  },
};
const animateText = {
  hidden: {
    opacity: 0,
    rotateY: 90,
    x: -200,
  },
  visible: {
    x: 0,
    opacity: 1,
    rotateY: 0,
    transition: {
      delay: 0.4,
      duration: 2,
    },
  },
};
function App(props) {
  return (
    <AnimateOnView
      variants={AnimateObject}
      tagName="div"
      style={{ border: "1px solid black" }}
    >
      <header className="App-header">
        <AnimateOnView variants={animateLogo} tagName="div">
          <img src={logo} className="App-logo" alt="logo" />
        </AnimateOnView>
        <AnimateOnView variants={animateText} tagName="p">
          {props.text}
        </AnimateOnView>
        <AnimateOnView
          variants={animateText}
          tagName="a"
          className="App-link"
          
          target="_blank"
          rel="noopener noreferrer"
        >
          <a href="https://github.com/sidv1905/AnimateOnView-example-App">See example repo here</a>
        </AnimateOnView>
        <AnimateOnView
          variants={animateText}
          tagName="a"
          className="App-link"
          href="https://www.framer.com/motion/"
          target="_blank"
          rel="noopener noreferrer"
        >
          You can definitely add styles by variants from framer-motion docs
        </AnimateOnView>
        <AnimateOnView variants={animateText} tagName="p">
          "Made By Siddharth Varangaonkar"
        </AnimateOnView>
      </header>
    </AnimateOnView>
  );
}

export default App;
